module.exports = __webpack_public_path__ + "img/CELC-w.a1fc41a8.png";